import { historyTier } from "@vb/ui";
import type { HistoryEntry } from "../store.js";

interface HistoryStripProps {
  results: HistoryEntry[];
  inline?: boolean; // when true, renders without its own heading row (parent supplies)
  onSelect?: (entry: HistoryEntry) => void;
}

export function HistoryStrip({ results, inline = false, onSelect }: HistoryStripProps) {
  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        overflowX: "auto",
        padding: inline ? 0 : "2px 0",
      }}
    >
      {results.map((r, i) => {
        const tier = historyTier(r.multiplier);
        const clickable = !!onSelect && r.roundId !== null;
        return (
          <button
            type="button"
            key={`${i}-${r.roundId ?? r.ts}`}
            disabled={!clickable}
            onClick={() => clickable && onSelect?.(r)}
            className={`vb-hist tier-${tier}`}
            title={clickable ? "Tap to verify this round" : `${r.multiplier.toFixed(2)}×`}
            style={{
              flex: "0 0 auto",
              padding: "3px 8px",
              fontSize: 11,
              border: "none",
              cursor: clickable ? "pointer" : "default",
              transition: "transform 120ms",
            }}
            onMouseEnter={(e) => {
              if (clickable) e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
            }}
          >
            {r.multiplier.toFixed(2)}×
          </button>
        );
      })}
    </div>
  );
}
